export class HttpService {
  public loading: boolean = false;

  public async get<T>(
    url: string,
    headers: Record<string, string>,
    callback: (data: T) => void,
    errorCallback: (data: unknown) => void
  ): Promise<void> {
    await this.requestCore<T>('GET', url, headers, undefined, callback, errorCallback);
  }

  public async post<T>(
    url: string,
    headers: Record<string, string>,
    data: unknown,
    callback: (data: T) => void,
    errorCallback: (data: unknown) => void
  ): Promise<void> {
    await this.requestCore<T>('POST', url, headers, data, callback, errorCallback);
  }

  private async requestCore<T>(
    method: string,
    url: string,
    headers: Record<string, string>,
    data: unknown,
    callback: (data: T) => void,
    errorCallback: (data: unknown) => void
  ): Promise<void> {
    this.loading = true;

    try {
      const response = await fetch(url, {
        method,
        headers,
        body: data !== undefined ? JSON.stringify(data) : undefined,
      });

      const responseData = await response.json().catch(() => null);

      if (!response.ok) {
        errorCallback(responseData);
        return;
      }

      callback(responseData as T);
    } catch (error) {
      errorCallback(error);
    } finally {
      this.loading = false;
    }
  }
}
